import React, { ReactNode, useContext } from "react";
import { SessaoARContext } from "../Contexts/SessaoContext";
import { EnumTipoUsuario } from "../../Models/Domain/AreaRestrita/Sessao";
import { App, Avatar, Button, Card, Col, Empty, Grid, Row, Typography } from "antd";
import { Formatacoes } from "../../Utils/Formatacao";
import { TypeAluno } from "../../Models/Domain/Pessoa/Aluno";

import { useCallback } from 'react';

const avatarAluno = require("../../Assets/avatar-aluno.jpg")

export const SelecaoDeAluno = (props: { children: ReactNode }) => {
    return <div>{props.children}</div>;
};

const SelecaoDeAlunoDoResponsavel: React.FC<{
    style?: React.CSSProperties,
    aoSelecionar: (aluno: TypeAluno) => any
}> = (props) => {

    const tamanhoDaTela = Grid.useBreakpoint()

    const SessaoAR = useContext(SessaoARContext);

    if (SessaoAR?.sessao?.tipoDeUsuario != EnumTipoUsuario.Responsavel) return (
        <Empty description="Tipo de usuário da sessão indefinido ou não correspondente" />
    )

    const alunos = SessaoAR.sessao.info?.alunos;

    if (alunos == undefined || alunos.length == 0) {
        return (
            <React.Fragment>
                <Empty
                    description={
                        <>
                            Nenhum aluno foi encontrado.
                            <br />
                            Consulte um administrador.
                        </>
                    }
                />
            </React.Fragment>
        );
    }

    return (
        <div style={{ ...props.style }}>
            <Row gutter={[16, 16]} justify={"space-evenly"}>
                {SessaoAR.sessao.info?.alunos?.map(({ aluno }) => (
                    <Col key={aluno.codigo} span={tamanhoDaTela.md ? 8 : 24}>
                        <Card
                            bordered
                            actions={[
                                <Button type="primary" onClick={() => {
                                    props.aoSelecionar(aluno)
                                }}>Continuar</Button>
                            ]}
                        >
                            <Card.Meta
                                title={<Typography style={{ textWrap: "wrap" }}> {aluno.pessoa?.nome} </Typography>}
                                avatar={<Avatar src={avatarAluno} />}
                                description={<> CPF: {Formatacoes.formatarCPF(aluno.pessoa?.cpf) ?? "N/A"} </>}
                            />
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    )
}

SelecaoDeAluno.ParaResponsavel = SelecaoDeAlunoDoResponsavel;

export const useSelecionarAluno: () => () => Promise<TypeAluno| null> = () => {

    const app = App.useApp()
    const context = useContext(SessaoARContext);

    return useCallback(async () => {
        return await new Promise<TypeAluno | null>(async (resolve) => {
            const k = app.modal.confirm({
                onCancel: () => {
                    resolve(null);
                    k.destroy() ;
                },
                footer: (_, {CancelBtn}) => <CancelBtn/>,
                cancelText: "Cancelar",
                title: "Selecione um Aluno",
                width: "80vw",
                content: (
                    <React.Fragment>
                        <SessaoARContext.Provider value={context}>
                            <SelecaoDeAlunoDoResponsavel aoSelecionar={(v) => {
                                resolve(v);
                                k.destroy()
                            }} /> 
                        </SessaoARContext.Provider>
                    </React.Fragment>
                ),
            });
        });

    }, []);
};
